<template>
  <div class="title">{{ formTitle }}</div>
  <a-form :model="salePersonForm" :rules="rules" ref="formRef" class="form">
    <a-form-item name="nickName" class="form-item">
      <template v-slot:label>
        <div class="label">昵称</div>
      </template>
      <a-input
        v-model:value="salePersonForm.nickName"
        placeholder="请输入昵称"
      />
    </a-form-item>
    <a-form-item name="username" class="form-item">
      <template v-slot:label>
        <div class="label">账号</div>
      </template>
      <a-input
        v-model:value="salePersonForm.username"
        placeholder="请输入账号"
      />
    </a-form-item>

    <a-form-item name="password" class="form-item">
      <template v-slot:label>
        <div class="label">登录密码</div>
      </template>
      <a-input
        v-model:value="salePersonForm.password"
        type="password"
        placeholder="请输入登录密码"
      />
    </a-form-item>

    <!-- <a-form-item name="phone" class="form-item">
        <template v-slot:label>
            <div class="label">手机号</div>
        </template>
        <a-input  v-model:value="salePersonForm.phone" placeholder="请输入手机号"/>
      </a-form-item>

      <a-form-item name="jobTitle" class="form-item">
        <template v-slot:label>
            <div class="label">职称</div>
        </template>
        <a-input  v-model:value="salePersonForm.jobTitle" placeholder="请输入职称"/>
      </a-form-item> -->
  </a-form>

  <div class="footer">
    <div class="cancel" @click="cancelAddSale">取消</div>
    <div class="queck" @click="addOrEditSale">确定</div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, toRaw } from "vue";
import { useStore } from "vuex";
import { insertAfterSale, updateAfterSale } from "@/request/view/afterSale";
import { saveOrUpdateUser } from "@/request/view/repair";
import { Toast } from "@/utils";

export default defineComponent({
  setup(props, content) {
    const store = useStore();

    const formRef = ref();

    const formTitle = ref("新增账号");

    const salePersonForm = reactive({
      username: "",
      password: "",
      id: "",
      nickName: "",
      pid: "",
    });
    // 重置表单
    const resetForm = () => {
      salePersonForm.username = "";
      salePersonForm.password = "";
      salePersonForm.id = "";
      salePersonForm.nickName = "";
      salePersonForm.pid = "";
    };
    // 编辑表单赋值
    const setFormData = (data) => {
      formTitle.value = "修改账号信息";
      salePersonForm.username = data.username;
      salePersonForm.nickName = data.nickName;
      salePersonForm.id = data.id;
      salePersonForm.password = data.password;
      salePersonForm.pid = data.pid;
    };

    const backPrePage = () => {
      const updateTable = formTitle.value === "新增账号";
      content.emit("updateTable", updateTable);
    };

    const cancelAddSale = () => {
      resetForm();
      content.emit("updateTable", false);
    };

    const setFormPid = (record) => {
      salePersonForm.pid = record.id;
      salePersonForm.type = record.type;
      console.log(salePersonForm, "表单信息是什么");
    };
    // 新增账号
    const addOrEditSale = () => {
      formRef.value.validate().then(() => {
        const update = {
          isEdit: formTitle.value === "修改账号信息",
          update: true,
        };
        localStorage.setItem("sale_update", JSON.stringify(update));
        saveOrUpdateUser(toRaw(salePersonForm))
          .then((res) => {
            if (res.code === 200) {
              notice("success", "提示", res.message, 3);
            } else {
              Toast("warning", res.message, 3);
              return;
            }
            resetForm();
            backPrePage();
          })
          .catch((err) => {
            resetForm();
            backPrePage();
          });
      });
    };

    const rules = {
      username: [
        {
          required: true,
          message: "请输入账号",
          trigger: "blur",
          type: "string",
        },
      ],
      password: [
        {
          required: true,
          message: "请输入登录密码",
          trigger: "blur",
          type: "string",
        },
      ],
    };

    return {
      salePersonForm,
      rules,
      cancelAddSale,
      addOrEditSale,
      backPrePage,
      formTitle,
      formRef,
      setFormData,
      setFormPid,
    };
  },
});
</script>

<style lang="less" scoped>
@import url("../../../../assets/less/mobileForm.less");
</style>
